import {Component} from '@angular/core';
import {TopMentionComponent} from '../top-mention/top-mention.component';
import {PdfExportService} from '../../../services/export-pdf/pdf-export.service';
import {UserService} from '../../../services/user.service';

@Component({
  selector: 'top-mention-placeholder',
  templateUrl: './top-mention-placeholder.component.html',
  styleUrls: ['./top-mention-placeholder.component.scss']
})
export class TopMentionPlaceholderComponent extends TopMentionComponent {

  constructor(protected pdfService: PdfExportService,
              protected userService: UserService) {
    super(pdfService, userService);
    this.data = [];
    for (let i = 0; i < 10; i++) {
      this.data.push({keyword: '', number: 10, bgColor: '#f7f7f8'});
    }
    this.isFallbackView = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/top-mention-placeholder/top-mention-placeholder.component.ts